import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "row h-xl-100" }
const _hoisted_2 = { class: "col-sm-12 col-md-12 col-lg-5 col-xl-5" }
const _hoisted_3 = { class: "card mb-4 card-flush h-xl-100" }
const _hoisted_4 = { class: "card-header p- border-" }
const _hoisted_5 = { class: "card-title text-primary" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-cloud-upload-fill fs-1 me-4 text-primary" }, null, -1)
const _hoisted_7 = { class: "card-body p-" }
const _hoisted_8 = { class: "d-flex align-items-center mb-6 flex-wrap" }
const _hoisted_9 = { class: "me-4" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-cloud-upload-fill fs-5x" }, null, -1)
const _hoisted_11 = { class: "el-upload__text mt-6" }
const _hoisted_12 = { class: "el-upload__tip text-center" }
const _hoisted_13 = { class: "col-sm-12 col-md-12 col-lg-7 col-xl-7" }
const _hoisted_14 = { class: "card card-flush h-xl-100" }
const _hoisted_15 = { class: "card-header p- border-" }
const _hoisted_16 = { class: "card-title text-primary" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-cloud-fill fs-1 me-4 text-primary" }, null, -1)
const _hoisted_18 = { class: "card-body p-" }
const _hoisted_19 = {
  key: 0,
  class: "d-flex flex-column"
}
const _hoisted_20 = { class: "fw-bolder" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_22 = { class: "fs-7" }
const _hoisted_23 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_VisorFile = _resolveComponent("VisorFile")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h3", _hoisted_5, [
              _hoisted_6,
              _createTextVNode(" " + _toDisplayString(_ctx.t('upload')) + " " + _toDisplayString(_ctx.t('files').toLowerCase()), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.t('up1')), 1),
              _createVNode(_component_el_select, {
                modelValue: _ctx.alias,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.alias) = $event)),
                placeholder: "Seleccione",
                filterable: "",
                class: "w-100"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listTypeFile, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.id,
                      label: item.name,
                      value: item.id
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createVNode(_component_el_upload, {
              ref: "upload",
              drag: "",
              headers: _ctx.headers,
              data: _ctx.dataUpload,
              name: "file",
              action: `${_ctx.urlUpload}/api/file/upload`,
              accept: ".pdf",
              limit: 1,
              multiple: false,
              "before-upload": _ctx.beforeUpload,
              "on-error": _ctx.handleError,
              "on-success": _ctx.handleSuccess
            }, {
              tip: _withCtx(() => [
                _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.t('up2')), 1)
              ]),
              default: _withCtx(() => [
                _hoisted_10,
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("em", null, _toDisplayString(_ctx.t('up3')), 1)
                ])
              ]),
              _: 1
            }, 8, ["headers", "data", "action", "before-upload", "on-error", "on-success"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("h3", _hoisted_16, [
              _hoisted_17,
              _createTextVNode(_toDisplayString(_ctx.t('uploaded')) + " " + _toDisplayString(_ctx.t('files').toLowerCase()), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            (_ctx.listFiles.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listFiles, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "item d-flex justify-content-between shadow-sm p-4 rounded mb-5 bg-light-warning align-items-center bg-hover-warning"
                    }, [
                      _createElementVNode("div", null, [
                        _createElementVNode("span", _hoisted_20, _toDisplayString(item.name) + "(" + _toDisplayString(item.alias) + ")", 1),
                        _hoisted_21,
                        _createElementVNode("span", _hoisted_22, _toDisplayString(item.created_at), 1)
                      ]),
                      _createElementVNode("a", {
                        onClick: ($event: any) => (_ctx.openVisorFile(item.ruta)),
                        target: "_blank",
                        class: "btn btn-sm bg-white border border-warning text-hover-warning"
                      }, _toDisplayString(_ctx.t('viewFile')), 9, _hoisted_23)
                    ]))
                  }), 128))
                ]))
              : _withDirectives((_openBlock(), _createBlock(_component_el_empty, {
                  key: 1,
                  description: _ctx.t('empty')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "success",
                      onClick: _ctx.getFiles
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.t('tryAgain')), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                }, 8, ["description"])), [
                  [_directive_loading, _ctx.loading]
                ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_VisorFile, { extra: _ctx.idacrd }, null, 8, ["extra"])
  ], 64))
}